module.exports = __webpack_public_path__ + "img/H-63-ER-1500-BE.df5a13a8.png";